import config from '../../config';

const { stripeApiKey } = config;

const stripe = require('stripe')(stripeApiKey);

export const retrieveSession = async (sessionId: string) => {
  try {
    const session = await stripe.checkout.sessions.retrieve(sessionId);

    return session;
  } catch (err: any) {
    throw new Error(`Error retrieving session: ${err.message}`);
  }
};
